var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import Input from '.'; // 這裡是 Input/index.tsx 的引入
var InputPassword = function (props) {
    var value = props.value, name = props.name, placeholder = props.placeholder, onChange = props.onChange, error = props.error, helperText = props.helperText, inputProps = props.inputProps, className = props.className, verifyBeforeChange = props.verifyBeforeChange, otherProps = __rest(props, ["value", "name", "placeholder", "onChange", "error", "helperText", "inputProps", "className", "verifyBeforeChange"]);
    var _a = useState(false), showPwd = _a[0], setShowPwd = _a[1];
    var _b = useState(''), message = _b[0], setMessage = _b[1];
    var toggleShowPwd = function () {
        setShowPwd(function (prev) { return !prev; });
    };
    var handleChange = function (e) {
        var val = e.target.value;
        // 只允許輸入英數與特殊符號（禁止輸入中日韓等非 ASCII 字元）
        var validPattern = /^[\x00-\x7F]*$/; // ASCII 範圍
        if (!validPattern.test(val)) {
            setMessage('僅允許輸入英數與符號');
            return;
        }
        if (verifyBeforeChange && val.length > 0) {
            setMessage('');
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    return (React.createElement(Input, __assign({ className: className, name: name, type: showPwd ? 'text' : 'password', placeholder: placeholder, value: value, onChange: handleChange, error: error, helperText: helperText, inputProps: inputProps, verifyBeforeChange: verifyBeforeChange, endAdornment: React.createElement("img", { src: showPwd ? '/image/eye-off.png' : '/image/eye.png', alt: "toggle visibility", onClick: toggleShowPwd, style: {
                cursor: 'pointer',
                height: '1.2em',
                marginRight: '0.5em',
            } }) }, otherProps)));
};
export default InputPassword;
